import React, { Component } from 'react';
import { Link } from 'react-scroll';
import siteConfig from 'siteConfig.js';
import { Icon, Menu, Responsive, Image } from 'semantic-ui-react'
import './Nav.sass'

class Nav extends Component {
	state = {
		activeItem: null,
	}

	revealedOnce = false;
	activeMenuItemHandler = (to) => this.setState({ activeItem: to });


	render() {
		let navItems = siteConfig.impactSpaces.map((el, idx) => {
			let menuStyles = {
				backgroundColor: el.color,
				color: 'white',
			};

			return(
				<Link className="navItem" activeClass='active' id={'link-' + el.id} spy={true} smooth={true} to={el.id} key={idx} offset={-150} onClick={this.props.hideNav} onSetActive={this.activeMenuItemHandler}>
					<Menu.Item style={menuStyles}>
						<Image className="icon" src={el.icon}></Image>
						{el.title}
					</Menu.Item>
				</Link>

			);
		});

		// Add the StartHacks logo
		navItems.unshift(
			<Menu.Item className="navItem header" key="header">
				<Image src={siteConfig.logos.shLogoFullVertical}></Image>
			</Menu.Item>
		)

		//Add the footer
		navItems.push(
			<Menu.Item className="navItem footer" key="footer">
				<div className="footerIcons">
					<a href="https://twitter.com/starterhacks">
						<Image src={siteConfig.logos.twitter}></Image>
					</a>
					<a href="https://www.facebook.com/starterhacks/">
						<Image src={siteConfig.logos.facebook}></Image>
					</a>
					<a href="https://www.instagram.com/starterhacks_/">
						<Image src={siteConfig.logos.instagram}></Image>
					</a>
				</div>
				<div className="footerText">
					© StarterHacks 2018
					<br/>
					All Rights Reserved
				</div>
			</Menu.Item>
		)





		this.revealedOnce = this.revealedOnce || this.props.visible;

		return (
			<div id="impactSpaceNav" className={!this.revealedOnce ? '' : this.props.visible ? 'slide-in' : 'slide-out'}>
				<Menu>
					{navItems}
				</Menu>
				<Responsive as={Icon} name="close" onClick={this.props.hideNav}></Responsive>
			</div>
		);
	}
}

export default Nav;
